import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircle } from "@fortawesome/free-solid-svg-icons";
import styles from "./PasswordRequirementsChecklist.module.css";

// R002-UX: mesmas regras de `_validate_password_strength` em
// app/schemas/pydantic.py — a validação de verdade continua só no backend
// (UserCreate.password e ChangeMyPassword.new_password), isso aqui é só
// feedback visual em tempo real pro aluno/professor não descobrir que a
// senha foi recusada só depois de enviar o form. Qualquer mudança nas regras
// do backend precisa vir acompanhada da mesma mudança aqui, senão o
// checklist passa a mentir sobre o que o servidor realmente aceita.
export const PASSWORD_RULES = [
  { id: "length", label: "Pelo menos 8 caracteres", test: (v) => v.length >= 8 },
  { id: "upper", label: "Uma letra maiúscula", test: (v) => /[A-Z]/.test(v) },
  { id: "digit", label: "Um número", test: (v) => /[0-9]/.test(v) },
  { id: "special", label: "Um caractere especial", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export function isPasswordStrong(value) {
  const v = value || "";
  return PASSWORD_RULES.every((rule) => rule.test(v));
}

/**
 * PasswordRequirementsChecklist
 *
 * Checklist de força de senha que vai "completando" item por item enquanto
 * o usuário digita — cada regra troca de ícone (círculo vazio → check) e cor
 * assim que é satisfeita, nunca só a cor sozinha (ver knowledge/16-microinteractions.md
 * "Color independence" e knowledge/06-accessibility.md do skill ux-product-designer).
 * `aria-live="polite"` avunça a mudança pra leitor de tela sem interromper.
 */
export default function PasswordRequirementsChecklist({ password }) {
  const value = password || "";
  return (
    <ul className={styles.list} aria-live="polite">
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(value);
        return (
          <li key={rule.id} className={met ? styles.itemMet : styles.item}>
            <FontAwesomeIcon icon={met ? faCircleCheck : faCircle} className={styles.icon} />
            <span>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
